var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        mousedown: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClose.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "delete-dialog" }, [
        _c("div", { staticClass: "delete-header" }, [
          _c("span", { staticClass: "delete-header-title" }, [
            _vm._v(
              _vm._s(_vm.$t("homePage.novelList.grouping.deleteConfirmTitle"))
            ),
          ]),
          _c(
            "button",
            { staticClass: "delete-close-button", on: { click: _vm.onClose } },
            [_c("IconClose", { staticClass: "delete-close-icon" })],
            1
          ),
        ]),
        _c("div", { staticClass: "delete-body" }, [
          _c("p", { staticClass: "delete-group-name" }, [
            _vm._v(_vm._s(_vm.groupName)),
          ]),
          _c("p", { staticClass: "delete-message" }, [
            _vm._v(
              _vm._s(
                _vm.$t("homePage.novelList.grouping.deleteConfirmMessage1")
              )
            ),
          ]),
          _c("p", { staticClass: "delete-message" }, [
            _vm._v(
              _vm._s(
                _vm.$t("homePage.novelList.grouping.deleteConfirmMessage2")
              )
            ),
          ]),
          _c("p", { staticClass: "delete-message" }, [
            _vm._v(
              _vm._s(
                _vm.$t("homePage.novelList.grouping.deleteConfirmMessage3")
              )
            ),
          ]),
        ]),
        _c("div", { staticClass: "delete-actions" }, [
          _c(
            "button",
            {
              staticClass: "delete-submit-button",
              on: { click: _vm.onDelete },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("homePage.novelList.grouping.delete")) + " "
              ),
            ]
          ),
          _c(
            "button",
            { staticClass: "delete-cancel-button", on: { click: _vm.onClose } },
            [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }